import { getCurrentSession } from '../auth/cognito';

const API_URL = process.env.REACT_APP_API_URL || '';

async function getAuthHeaders() {
  const session = await getCurrentSession();
  if (!session) {
    throw Object.assign(new Error('Not authenticated'), { status: 401 });
  }
  const idToken = session.session.getIdToken().getJwtToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${idToken}`,
  };
}

export async function apiPost(path, body) {
  const headers = await getAuthHeaders();
  const res = await fetch(`${API_URL}${path}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });

  if (res.status === 401) {
    window.location.href = '/login';
    throw Object.assign(new Error('Session expired'), { status: 401 });
  }

  const data = await res.json();
  if (!res.ok) {
    throw Object.assign(new Error(data.error || 'Request failed'), { status: res.status, data });
  }
  return data;
}

export async function apiGet(path) {
  const headers = await getAuthHeaders();
  const res = await fetch(`${API_URL}${path}`, {
    method: 'GET',
    headers,
  });

  if (res.status === 401) {
    window.location.href = '/login';
    throw Object.assign(new Error('Session expired'), { status: 401 });
  }

  const data = await res.json();
  if (!res.ok) {
    throw Object.assign(new Error(data.error || 'Request failed'), { status: res.status, data });
  }
  return data;
}
